import usePermissions from 'shared/src/hooks/usePermissions';

const IfPermissions = ({ children, context, permissions }) => {
  const hasPermissions = usePermissions(context, permissions);
  return hasPermissions ? children : null;
};

export default IfPermissions;
